import React from 'react';
import StudentLogin from './StudentLogin';

// IPMAT-only entry point. The legacy CSV "AI Analytics" dashboard was CAT-domain
// dead code (unreachable — App.js always supplies onStudentLogin, so the local
// dashboard branch never ran). HomePage now simply renders the login screen and
// delegates navigation to App.js.
const HomePage = ({ onStudentLogin }) => {
  return <StudentLogin onStudentLogin={onStudentLogin} />;
};

export default HomePage;
